import React from "react";

const CustomerReviews = () => {
  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const WHITE = "#ffffff";
  const LIGHT_BG = "#faf8f4";

  const reviews = [
    {
      id: 1,
      name: "Sarah M.",
      text: "Absolutely love the craftsmanship! The wooden vase added such warmth and charm to my home.",
      rating: 5,
    },
    {
      id: 2,
      name: "Omar A.",
      text: "High-quality materials and elegant design. You can feel the passion behind each piece.",
      rating: 5,
    },
    {
      id: 3,
      name: "Nour E.",
      text: "The mirror frame is stunning! It looks even better in real life. Fast delivery and great packaging.",
      rating: 4,
    },
  ];

  const section = {
    background: LIGHT_BG,
    padding: "80px 20px",
    textAlign: "center",
    fontFamily: "Inter, system-ui, sans-serif",
  };

  const title = {
    fontSize: 36,
    color: BROWN,
    fontWeight: 700,
    marginBottom: 50,
  };

  const grid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 24,
    maxWidth: 1000,
    margin: "auto",
  };

  const card = {
    background: WHITE,
    padding: "30px 20px",
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
    border: `1px solid ${OLIVE}33`,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };

  const name = {
    marginTop: 15,
    fontWeight: 600,
    color: BROWN,
    fontSize: 18,
  };

  const text = {
    color: "#555",
    fontSize: 16,
    lineHeight: 1.6,
  };

  const stars = {
    color: OLIVE,
    fontSize: 20,
    margin: "10px 0",
  };

  const responsive = `
    .review-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    }
  `;

  return (
    <section style={section} id="reviews">
      <style>{responsive}</style>

      <h2 style={title}>What Our Customers Say</h2>

      <div style={grid}>
        {reviews.map((r) => (
          <div key={r.id} style={card} className="review-card">
            <p style={text}>“{r.text}”</p>
            <div style={stars}>{"⭐".repeat(r.rating)}</div>
            <p style={name}>{r.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CustomerReviews;
